const { fetchAuthorizedJsonApi } = require('./abstract');

function redeemCode(apiUrl, token, data, headers = {}) {
  return fetchAuthorizedJsonApi({
    apiUrl,
    token,
    method: 'PUT',
    endpoint: 'v1/codes/redeem',
    headers,
    body: data,
    expectedStatus: 200,
    description: 'Redeeming code',
  });
}

module.exports = {
  redeemCode,
};
